import * as React from "react";
import { Button, ButtonProps, Steps } from "antd";

export interface CreateFormLink {
  name: string;
  value: string;
  isActive: boolean;
  pushTop?: boolean;
}

interface Props extends React.PropsWithChildren {
  title: string;
  buttons: ButtonProps[];
  stepCurrent: number;
}
export const CreateAccountLayout: React.FC<Props> = ({ title, stepCurrent, buttons, children }) => {
  return (
    <div className={`relative account-create`}>
      <Steps
        className="mb-12"
        current={stepCurrent}
        items={[{ title: "Account" }, { title: "Address" }, { title: "Payment Method" }, { title: "Org & GVC" }]}
      />
      <div>
        <div className="text-2xl" style={{ minHeight: 48 }}>
          {title}
        </div>
        {children}
      </div>
      <div className="flex items-center justify-center mt-8 gap-3">
        {buttons.map((b, i) => (
          <Button key={i} {...b} />
        ))}
      </div>
    </div>
  );
};
